export default {"src":"/_next/static/media/hourofai.5d6d0f74.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};